module.exports = __webpack_public_path__ + "76ec96fde5ec96d8b791e4e7d020a134.jpg";